<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Projeções Financeiras</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" :to="{ name: 'projecaoFinanceiraNova' }">
          <v-icon left>mdi-plus-circle-outline</v-icon> Nova Projeção
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        loading-text="Carregando..."
        no-data-text="Nenhuma projeção salva. Clique em 'Nova Projeção' para começar."
        :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
        @click:row="abrir"
        class="row-pointer"
      >
        <template v-slot:item.quantidadeAlunos="{ item }">
          {{ (item.input && item.input.quantidadeAlunos) || '-' }}
        </template>
        <template v-slot:item.dataInicio="{ item }">
          {{ (item.input && item.input.dataInicio) | moment('MM/YYYY') }}
        </template>
        <template v-slot:item.saldoFinal="{ item }">
          {{ ((item.kpis && item.kpis.saldoFinal) || 0) | price }}
        </template>
        <template v-slot:item.lucroProjetado="{ item }">
          {{ ((item.kpis && item.kpis.lucroProjetado) || 0) | price }}
        </template>
        <template v-slot:item.lastUpdate="{ item }">
          {{ formatDate(item.lastUpdate) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn :to="{ name: 'projecaoFinanceiraDetalhe', params: { id: item.id } }" color="primary" fab text small @click.stop>
            <v-icon>mdi-file-find</v-icon>
          </v-btn>
          <v-btn color="error" fab text small @click.stop="confirmarExclusao(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog v-model="dialogDelete" max-width="420">
      <v-card>
        <v-card-title class="subtitle-1">Excluir projeção</v-card-title>
        <v-card-text>
          Tem certeza que deseja excluir a projeção
          <strong>{{ selecionada && selecionada.nomeTurma }}</strong>? Esta ação não pode ser desfeita.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDelete = false">Cancelar</v-btn>
          <v-btn color="error" :loading="deleting" @click="excluir">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import { mapMutations } from 'vuex'
import { listProjecoes, removeProjecao } from './projecaoStorage'

export default {
  name: 'ProjecaoList',
  data: () => ({
    loading: false,
    deleting: false,
    dialogDelete: false,
    selecionada: null,
    items: [],
    headers: [
      { text: 'Nome da Turma', value: 'nomeTurma' },
      { text: 'Alunos', value: 'quantidadeAlunos', sortable: false },
      { text: 'Início', value: 'dataInicio', sortable: false },
      { text: 'Saldo Final', value: 'saldoFinal', sortable: false },
      { text: 'Lucro Projetado', value: 'lucroProjetado', sortable: false },
      { text: 'Atualizado em', value: 'lastUpdate' },
      { text: '', value: 'actions', sortable: false, align: 'end' }
    ]
  }),
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    getData () {
      this.loading = true
      listProjecoes()
        .then(items => {
          this.items = items
          this.loading = false
        })
        .catch(() => {
          this.SET_SNACKBAR({ text: 'Houve um erro ao carregar as projeções.' })
          this.loading = false
        })
    },
    abrir (item) {
      this.$router.push({ name: 'projecaoFinanceiraDetalhe', params: { id: item.id } })
    },
    confirmarExclusao (item) {
      this.selecionada = item
      this.dialogDelete = true
    },
    excluir () {
      this.deleting = true
      removeProjecao(this.selecionada.id)
        .then(() => {
          this.SET_SNACKBAR({ text: 'Projeção excluída' })
          this.items = this.items.filter(i => i.id !== this.selecionada.id)
          this.dialogDelete = false
          this.deleting = false
        })
        .catch(() => {
          this.SET_SNACKBAR({ text: 'Houve um erro ao excluir a projeção.' })
          this.deleting = false
        })
    },
    formatDate (timestamp) {
      if (!timestamp) return '-'
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp)
      return this.$moment(date).format('DD/MM/YYYY HH:mm')
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style scoped>
.row-pointer >>> tbody tr {
  cursor: pointer;
}
</style>
